/**
 * Renders composer copy that marks its named subject with `**bold**`: each
 * run becomes a <b> at 600 in primary ink (the lede's subject), everything
 * else stays plain text. Replaces six private copies of the same splitter.
 * Renders a fragment, so it can sit inside a <p>, an <h1> or a cell.
 */
export interface MarkedProps {
  text: string
}

export function Marked({ text }: MarkedProps) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g)
  return (
    <>
      {parts.map((part, i) =>
        part.length > 4 && part.startsWith('**') && part.endsWith('**') ? (
          <b key={i} className="font-semibold text-text-primary">
            {part.slice(2, -2)}
          </b>
        ) : (
          part
        ),
      )}
    </>
  )
}

export default Marked
